import DiscoverMoreSection from 'features/home/HomeScreen/components/DiscoverMoreSection/DiscoverMoreSection';
import ExternalAccountsCard from 'features/home/HomeScreen/components/ExternalAccountsCard/ExternalAccountsCard';
import MarketingCardCarousel from 'features/home/HomeScreen/components/MarketingCardCarousel/MarketingCardCarousel';
import ProgressCheckList from 'features/home/HomeScreen/components/ProgressCheckList/ProgressCheckList';
import CheckImagePreview from 'features/rdc/components/CheckImagePreview/CheckImagePreview';
import CheckDepositImagesAndAgreement from 'features/rdc/screens/CheckDepositHistory/CheckDepositHistoryDetails/CheckDepositImagesAndAgreement';
import ActivatedOfferCard from 'features/rewards/components/ActivatedOfferCard/ActivatedOffer';
import BoostPromoCard from 'features/rewards/components/BoostPromoCard/BoostPromoCard';
import CashbackEarnedCard from 'features/rewards/components/CashbackEarnedCard/CashbackEarnedCard';
import HomeActivatedOfferCard from 'features/rewards/components/HomeActivatedOfferCard/HomeActivatedOfferCard';
import HomeOfferCard from 'features/rewards/components/HomeOfferCard/HomeOfferCard';
import DynamicMapCard from 'features/rewards/components/MapCard/DynamicMapCard';
import MapsCard from 'features/rewards/components/MapCard/MapsCard';
import MyOfferTileCard from 'features/rewards/components/MyOfferTileCard/MyOfferTileCard';
import OfferCard from 'features/rewards/components/OfferCard/OfferCard';
import { PressableSectionHeaderV2 } from 'features/rewards/components/PressableSectionHeaderV2';
import NearbyOffersCarousel from 'features/rewards/components/rewardsCarousels/NearbyOffersCarousel';
import StandardCard from 'features/rewards/components/StandardCard/StandardCard';
import { ReactNode } from 'react';
import HTMLComponent from 'shared/components/HTMLRenderer/HTMLComponent/HTMLComponent';
import ProductOfferCardNonActionable from 'shared/components/ProductOfferCardNonActionable/ProductOfferCardNonActionable';
import StackedTextAccessories from 'shared/components/StackedTextAccessories/StackedTextAccessories';
import IconAvatar from 'shared/components/vxl/avatar/IconAvatar/IconAvatar';
import UserAvatar from 'shared/components/vxl/avatar/UserAvatar/UserAvatar';
import AvatarCard from 'shared/components/vxl/AvatarCard/AvatarCard';
import Badge from 'shared/components/vxl/Badge/Badge';
import Button from 'shared/components/vxl/Button/Button';
import BrazeCard from 'shared/components/vxl/cards/BrazeCard/BrazeCard';
import ColumnTaxHomeTile from 'shared/components/vxl/cards/ColumnTaxTile/ColumnTaxCard';
import { CreditScoreCard } from 'shared/components/vxl/cards/CreditScoreCard/CreditScoreCard';
import HorizontalAccountCard from 'shared/components/vxl/cards/HorizontalAccountCard/HorizontalAccountCard';
import OnboardingCard from 'shared/components/vxl/cards/OnboardingCard/OnboardingCard';
import WalletOnboardingCard from 'shared/components/vxl/cards/OnboardingCard/WalletOnboardingCard/WalletOnboardingCard';
import ProductOfferCard from 'shared/components/vxl/cards/ProductOfferCard/ProductOfferCard';
import TrackerCard from 'shared/components/vxl/cards/TrackerCard/TrackerCard';
import VXLPromoCard from 'shared/components/vxl/cards/VXLPromoCard/VXLPromoCard';
import SectionDivider from 'shared/components/vxl/divider/SectionDivider/SectionDivider';
import Icon from 'shared/components/vxl/icon/Icon/Icon';
import { InlineAlert } from 'shared/components/vxl/InlineAlert/InlineAlert';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import ListItemTextStack from 'shared/components/vxl/ListItem/ListItemTextStack';
import PageTitle from 'shared/components/vxl/navigation/PageTitle/PageTitle';
import { OnboardingCarousel } from 'shared/components/vxl/OnboardingCarousel/OnboardingCarousel';
import FilterChip from 'shared/components/vxl/selection/FilterChip/FilterChip';
import Switch from 'shared/components/vxl/selection/Switch/Switch';
import { Tag } from 'shared/components/vxl/Tag/Tag';
import Tracker from 'shared/components/vxl/Tracker/Tracker';
import TransactionListItem from 'shared/components/vxl/TransactionListItem/TransactionListItem';
import BodySmText from 'shared/components/vxl/typography/primary/body/BodySmText';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
// end TODO:
import { VXLComponentId } from 'shared/renderer/types';

export type ComponentRegistryType = {
  [key in VXLComponentId]: (props: unknown) => React.JSX.Element | ReactNode;
};

const ComponentRegistry: ComponentRegistryType = {
  ACTIVATED_OFFER_CARD: ActivatedOfferCard,
  AVATAR_CARD: AvatarCard,
  BADGE: Badge,
  BOOST_PROMO_CARD: BoostPromoCard,
  BODY_SM_TEXT: BodySmText,
  BODY_XS_TEXT: BodyXSText,
  BRAZE_CARD: BrazeCard,
  BUTTON: Button,
  CASHBACK_EARNED_CARD: CashbackEarnedCard,
  CHECK_DEPOSIT_IMAGES_AND_AGREEMENT: CheckDepositImagesAndAgreement,
  CHECK_IMAGE_PREVIEW: CheckImagePreview,
  COLUMN_TAX_CARD: ColumnTaxHomeTile,
  CREDIT_SCORE_CARD: CreditScoreCard,
  DISCOVER_MORE_SECTION: DiscoverMoreSection,
  DYNAMIC_MAP_CARD: DynamicMapCard,
  EXTERNAL_ACCOUNTS_CARD: ExternalAccountsCard,
  FILTER_CHIP: FilterChip,
  HOME_ACTIVATED_OFFER_CARD: HomeActivatedOfferCard,
  HOME_OFFER_CARD: HomeOfferCard,
  HORIZONTAL_ACCOUNT_CARD: HorizontalAccountCard,
  HTML_COMPONENT: HTMLComponent,
  ICON: Icon,
  ICON_AVATAR: IconAvatar,
  INLINE_ALERT: InlineAlert,
  LIST_ITEM: ListItem,
  LIST_ITEM_TEXT_STACK: ListItemTextStack,
  MAPS_CARD: MapsCard,
  MARKETING_CARD_CAROUSEL: MarketingCardCarousel,
  MY_OFFERS_CARD: MyOfferTileCard,
  OFFER_CARD: OfferCard,
  ONBOARDING_CARD: OnboardingCard,
  ONBOARDING_CARD_CAROUSEL: OnboardingCarousel,
  PAGE_TITLE: PageTitle,
  PRESSABLE_SECTION_HEADER_V2: PressableSectionHeaderV2,
  PRODUCT_OFFER_CARD: ProductOfferCard,
  PRODUCT_OFFER_CARD_NON_ACTIONABLE: ProductOfferCardNonActionable,
  PROGRESS_CHECK_LIST: ProgressCheckList,
  SECTION_DIVIDER: SectionDivider,
  STACKED_TEXT_ACCESSORIES: StackedTextAccessories,
  STANDARD_CARD: StandardCard,
  SWITCH: Switch,
  TAG: Tag,
  TRACKER: Tracker,
  TRACKER_CARD: TrackerCard,
  TRANSACTION_LIST_ITEM: TransactionListItem,
  USER_AVATAR: UserAvatar,
  WALLET_ONBOARDING_CARD: WalletOnboardingCard,
  VXL_PROMO_CARD: VXLPromoCard,
  NEARBY_OFFERS_CAROUSEL: NearbyOffersCarousel,
};

export default ComponentRegistry;
